import React, {useState} from 'react'
import {toast} from 'react-toastify'

export const AgreedTermNote = ({
  checkBoxesValues,
  setCheckBoxesValues,
  isAgreeCheckboxDisabled,
  isKCCExist = false,
  showAdyenPrivacy = true,
}) => {
  const [isKCCAgreementChecked, setKCCAgreementCheckedStatus] = useState(false)
  const [isTCAgreed, setTCAgreedStatus] = useState(false)
  const isDisabled = isAgreeCheckboxDisabled
  const isAgreed = isKCCExist ? isTCAgreed : checkBoxesValues.agreedTerms
  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          padding: '10px 12px',
          borderRadius: '8px',
          boxShadow: '0 0 0 2px #5378FC',
          background: '#ffffff',
        }}
      >
        <span
          onClick={
            isDisabled
              ? () => toast.warn('Please complete your payment information.')
              : undefined
          }
          style={{
            display: 'flex',
            cursor: isDisabled ? 'not-allowed' : 'auto',
            flexShrink: 0,
          }}
        >
          <input
            type="checkbox"
            id="agreed-terms"
            name="terms"
            checked={isAgreed}
            disabled={isDisabled}
            title={
              isAgreeCheckboxDisabled
                ? 'Please complete your payment information.'
                : undefined
            }
            onChange={a => {
              const value = a.currentTarget.checked
              setTCAgreedStatus(value)
              setCheckBoxesValues({
                ...checkBoxesValues,
                agreedTerms: isKCCExist
                  ? value && isKCCAgreementChecked
                  : value,
              })
            }}
            style={{
              cursor: isDisabled ? 'not-allowed' : 'pointer',
              width: '16px',
              height: '16px',
              accentColor: '#5378FC',
              pointerEvents: isDisabled ? 'none' : 'auto',
            }}
          />
        </span>
        <label
          htmlFor="agreed-terms"
          className="card-number-helper-text"
          onClick={
            isDisabled
              ? () => toast.warn('Please complete your payment information.')
              : undefined
          }
          style={{
            marginTop: 0,
            cursor: isDisabled ? 'not-allowed' : 'pointer',
            fontWeight: 700,
            fontSize: '13px',
          }}
        >
          By checking this box, you agree to our{' '}
          <a
            target="_blank"
            href="https://corporate.thryv.com/terms/"
            rel="noreferrer"
            style={{fontWeight: 700, color: '#5378FC'}}
          >
            Terms & Conditions
          </a>
          <span style={{color: '#FF5000'}}> *</span>
        </label>
      </div>
      {isKCCExist && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            marginTop: '6px',
          }}
        >
          <input
            type="checkbox"
            id="kcc-terms"
            name="kcc-terms"
            checked={isKCCAgreementChecked}
            disabled={isDisabled}
            onChange={e => {
              setKCCAgreementCheckedStatus(e.currentTarget.checked)
              setCheckBoxesValues({
                ...checkBoxesValues,
                agreedTerms: isTCAgreed && e.currentTarget.checked,
              })
            }}
            style={{
              cursor: 'pointer',
              width: '16px',
              height: '16px',
              accentColor: '#5378FC',
              flexShrink: 0,
            }}
          />
          <label
            htmlFor="kcc-terms"
            className="card-number-helper-text"
            style={{marginTop: 0, cursor: 'pointer'}}
          >
            By checking this box, you agree to the{' '}
            <a
              target="_blank"
              href="https://assets.thryv.com/prod/pdfs/Thryv%20Certified%20Partner%20Agreement%20May%202026.pdf"
              rel="noreferrer"
              style={{fontWeight: 700, color: '#5378FC'}}
            >
              Certified Partner Agreement
              <span style={{color: 'red'}}>*</span>
            </a>
          </label>
        </div>
      )}
      {showAdyenPrivacy && (
        <p className="card-number-helper-text" style={{marginTop: '4px'}}>
          By processing your payment, you agree that your personal information
          will be shared with Thryv&apos;s payment processor—Adyen, N.V. and
          will be subject to Adyen&apos;s{' '}
          <a
            target="_blank"
            href="https://www.adyen.com/policies-and-disclaimer/privacy-policy"
            rel="noreferrer"
            style={{fontWeight: 700, color: '#5378FC'}}
          >
            privacy statement
          </a>
          .
        </p>
      )}
    </>
  )
}
